"use client";

import React, { useEffect, useRef, useState } from 'react'

import RichText from "bwax-ui/basic/RichText";

import clsx from 'clsx';
import ClampedText from './ClampedText';

import throttle from 'lodash/throttle';

export default function RichTextView({ value, keywords = {} }) {

    const outlineRef = useRef();

    const ref = useRef();

    const [ fixed, setFixed ] = useState();
    // const [ hidden, setHidden ] = useState();

    const [ outline, setOutline ] = useState();  // [ { heading, items: <>, hid, }]

    const fixedTop = 120;

    // 默认在左边
    const fixedRef = useRef(fixed);
    fixedRef.current = fixed;
    function handleScroll() {
        const el = outlineRef.current;

        if(el) {
            const rect = el.getBoundingClientRect();
            if(rect.top < fixedTop && !fixedRef.current) {
                setFixed(true)
            } else if(rect.top >= fixedTop && fixedRef.current) {
                setFixed(false)
            }
        }
    }

    const [viewing, setViewing] = useState();

    function detectHeadingInView() {
        if(ref.current) {
            const headings = ref.current.querySelectorAll(`[data-heading="true"]`)
        
            const rects = Array.from(headings).map(h => {
                const rect = h.getBoundingClientRect();
                const hid = h.getAttribute("data-hid");
                if(rect.top > 0) {
                    return [hid, rect.top]
                }
            }).filter(x => !!x)
            
            const centerV = window.innerHeight / 2;

            const nearest = rects.reduce((acc, current) => {
                if(acc && Math.abs(centerV - acc[1]) < Math.abs(centerV - current[1])) {
                    return acc
                } else {
                    return current
                }
            }, null);

            if(nearest && viewing !== nearest[0]) {
                setViewing(nearest[0])
            } else if(!nearest && viewing) {
                setViewing(null)
            }

        }
    }


    useEffect(() => {
        const container = window;

        const throttledDetect = throttle(detectHeadingInView, 32);

        container.addEventListener('scroll', handleScroll)
        container.addEventListener('scroll', throttledDetect);

        return () => {
            container.removeEventListener('scroll', handleScroll)
            container.removeEventListener('scroll', throttledDetect)
        }
    }, []);


    function renderOutline() {
        if(!outline || outline.length == 0) {
            return null
        }

        const outlineDiv = outline ? (
            <div className="w-full h-full ">
                {
                    outline.map(o => {
                        const { depth, hid, text } = o;
                        return (
                            <div key={hid} className={clsx("flex items-center py-1.5 cursor-pointer hover:opacity-100", {
                                "font-size-14": depth <= 2,
                                "font-size-13": depth > 2,
                                "opacity-60": viewing !== hid,
                                "opacity-95": viewing == hid,
                            })} style={{
                                gap: (depth - 1) * 16
                            }} onClick={_ => { 

                                if(ref.current) {
                                    const div = ref.current.querySelector(`[data-hid="${hid}"]`)

                                    // console.log(div);
                                    if(div) {
                                        div.scrollIntoView({
                                            behavior: "smooth",
                                            block: "center",
                                        })
                                    }

                                }

                            }}>
                                <div className="h-1 bg-[var(--gray-5)] rounded-full" style={{
                                    width: {
                                        2: 16,
                                        3: 12,
                                        4: 8
                                    }[depth] || 16
                                }}></div>
                                <ClampedText text={text} tipEnabled={false} />
                            </div>
                        )

                    })
                }
            </div>
        ) : null

        return (
            <>
                <div className={clsx("max-w-[16rem] h-[20rem] absolute top-6 -translate-x-[100%] py-4 pl-2 pr-8 xl:pr-16 hidden lg:block", {
                    "invisible": fixed
                })} ref={outlineRef}>
                    {outlineDiv}
                </div>
                <div style={{ top: fixedTop }} className={clsx("max-w-[16rem] h-[20rem] fixed -translate-x-[100%] py-4 pl-2 pr-8 xl:pr-16 hidden lg:block", {
                    "invisible": !fixed
                })}>
                    {outlineDiv}
                </div>
            </>

        )
    }

    return (
        <div className="relative" ref={ref}>
            <RichText className="leading-[1.75] pt-6 pb-4 text-[1rem] px-0.5" params={{ value }} outlineReady={outline => setOutline(outline)} keywords={keywords}/>
            {renderOutline()}
        </div>
    )
}
